export default function getResource(label) {
    const resources = {
        compareProducts: 'Compare Products',
        emptySlot: 'Empty',
        colors: 'Colors',
        sizes: 'Sizes',
        ratingsAndReviews: 'Rating & Reviews',
        overview: 'Overview',
        ingredients: 'Ingredients',
        pickupAndDelivery: 'Pickup & Delivery'
    };

    return resources[label];
}
